import './common'
import '../scss/style.scss';

import '~components/forms/select/select';
import '~components/forms/file/file'